<template>
    <div>
        <a-modal
            centered
            title="录入客户"
            :visible="visible"
            :confirm-loading="submitting"
            @ok="on_ok"
            @cancel="on_cancel"
            :width="970"
            :maskClosable="false"
            :after-close="after_close"
        >
            <a-form-model :model="form" ref="member-create" :rules="rules">
                <a-divider orientation="left">基本信息</a-divider>
                <a-row :gutter="24">

                  <a-col :span="6">
                    <a-form-model-item label="公司名称" prop="com_name">
                      <a-input v-model="form.com_name" placeholder="" >
<!--                        <a-icon slot="prefix" type="icon icon-me" />-->
                      </a-input>
                    </a-form-model-item>
                  </a-col>

                    <a-col :span="6">
                        <a-form-model-item label="客户姓名" prop="name">
                            <a-input placeholder="必填" v-model="form.name">
                                <a-icon slot="prefix" type="icon icon-me" />
                            </a-input>
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="6">
                        <a-form-model-item label="手机号码" prop="mobile">
                            <a-input max="11" type="number" v-model="form.mobile" @change="on_mobile_change" :loading="phone_checking">
                                <a-icon slot="prefix" type="icon icon-shouji1" />
                            </a-input>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="微信号">
                            <a-input v-model="form.wechat_id">
                                <a-icon slot="prefix" type="icon icon-we-chat-s" />
                            </a-input>
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="6">
                        <a-form-model-item label="QQ">
                            <a-input v-model="form.qq">
                                <a-icon slot="prefix" type="icon icon-qq1" />
                            </a-input>
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="6">
                        <a-form-model-item label="来源渠道" prop="source_id">
                            <a-button @click="visible_source = true" block v-if="!text_source">点击选择</a-button>
                            <a-button @click="visible_source = true" block v-else type="primary" ghost>{{ text_source }}</a-button>
                            <input type="hidden" v-model="form.source_id" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="身份" prop="taxonomy">
                            <a-radio-group v-model="form.taxonomy" button-style="solid">
                                <a-radio-button value=2>渠道</a-radio-button>
                                <a-radio-button value=1>直客</a-radio-button>
                                <a-radio-button value=3>代理商</a-radio-button>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="客户需求" prop="demand_type">
                            <a-select allow-clear mode="multiple" @change="on_demand_select" >
                                <a-select-option value="0">其他</a-select-option>
                                <a-select-option v-for="item in demand_type_array" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="6">
                        <a-form-model-item label="地区">
                            <a-cascader
                                    :options="option_area"
                                    placeholder="选择地址"
                                    @change="on_area_select"
                            />
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-model-item label="客户属性">
                            <a-radio-group v-model="form.member_type" button-style="solid">
                                <a-radio-button value="valid">有效客户</a-radio-button>
                                <a-radio-button value="low">低预算</a-radio-button>
                                <a-radio-button value="block">5次未接</a-radio-button>
                                <a-radio-button value="invalid">无效沟通</a-radio-button>
                                <a-radio-button value="trouble">捣乱</a-radio-button>
                                <a-radio-button value="colleagues">同行</a-radio-button>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-model-item label="客户等级">
                            <a-radio-group v-model="form.level" button-style="solid">
                                <a-radio-button :value="item.value" v-for="item in level_array" :key="item.value">
                                    <a-tooltip>
                                        <template slot="title">
                                            {{ item.name }}
                                        </template>
                                        {{ item.value }}
                                    </a-tooltip>
                                </a-radio-button>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-divider orientation="left">其他</a-divider>
                <a-row :gutter="24">
                    <a-col :span="6">
                        <a-form-model-item label="归属销售（默认本人）">
                            <a-select v-model="form.user_id">
                                <a-select-option v-for="item in basic_data_user" :key="item.id">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="商标需求">
                            <a-button @click="visible_trademark = true" block v-if="!text_trademark">点击选择</a-button>
                            <a-button @click="visible_trademark = true" block v-else type="primary" ghost>{{ text_trademark }}</a-button>
                            <input type="hidden" v-model="form.trademark_types" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="信息备注">
                            <a-input type="textarea" v-model="form.remark" :auto-size="{ minRows: 1, maxRows: 6 }" />
                        </a-form-model-item>
                    </a-col>
<!--                    <a-col :span="12">-->
<!--                        <a-form-model-item label="客户地址">-->
<!--                            <a-input v-model="form.full_address"></a-input>-->
<!--                        </a-form-model-item>-->
<!--                    </a-col>-->
                </a-row>

                <a-divider orientation="left">来源信息</a-divider>
                <a-row :gutter="24">
                    <!-- <a-col :span="6">
                        <a-form-model-item label="公司职位">
                            <a-select v-model="form.com_position">
                                <a-select-option v-for="item in position_array" :key="item.value">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col> -->

                    <a-col :span="6">
                        <a-form-model-item label="来源网页">
                            <a-input v-model="form.com_site" />
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="6">
                        <a-form-model-item label="来源关键字">
                            <a-input v-model="form.shop_name" />
                        </a-form-model-item>
                    </a-col>
                </a-row>


            </a-form-model>
        </a-modal>

        <!-- 来源渠道 -->
        <modal_source
            :visible="visible_source"
            @close="visible_source = false"
            :callback="select_callback"
            :checked_id="form.source_id"
        />
        <!-- 商标类型-->
        <modal_trademark
                :visible="visible_trademark"
                @close="visible_trademark = false"
                @change="(e) => trademark_callback(e)"
                :record="form.trademark_types"
        />
    </div>
</template>
<script>
    import area from "../../../mixins/area";
    // import basic_data from "../../../mixins/basic_data";
    import moment from "moment";
    import modal_source from "../../components/modal_source";
    import modal_trademark from "../../components/modal_trademark";

    let init_form = {
        name: null,
        mobile: null,
        source_id: null,
        demand_type: null,
        remark: null,
        wechat_id: null,
        qq: null,
        com_site: null,
        com_position: null,
        com_name: null,
        level: 1,
        shop_name: null,
      taxonomy: 1,
        user_id: null,
        full_address: null,
        member_area: null, //用户区域
        member_type: null, //客户属性
        trademark_types: null, //商标需求类别
        promote_source_id: null, //来源id
    };
    export default {
        components: {modal_trademark, modal_source },

        data() {
            return {
                phone_checking: false,
                visible_source: false,
                visible_trademark: false,
                visible_project: false,
                visible_industry: false,
                text_source: undefined,
                text_trademark: undefined,
                text_industry: undefined,
                option_area: area,
                form: {},
                rules: {
                    name: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "填写客户姓名",
                        },
                    ],
                    com_name: [
                      {
                        required: true,
                        trigger: ["change", "blur"],
                        message: "公司名称必填",
                      },
                    ],
                    /*mobile: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "填写手机号码",
                        },
                    ],*/
                    sex: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "选择性别",
                        },
                    ],
                    source_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "选择来源渠道",
                        },
                    ],
                    demand_type: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "选择客户需求",
                        },
                    ],
                  taxonomy: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请选择客户身份",
                        },
                    ],
                },
                age: null,
                submitting: false,
                data_economic_condition: [],
                // data_intention: [],
                data_doctor: [],
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
            this.load_basic_user();

             this.load_basic_source();
        },
        computed: {
            visible() {
                return this.$store.state.member_create_visible;
            },
            callback() {
                return this.$store.state.member_create_callback;
            },
        },
        methods: {
            moment,
            disabled_birthdate(v) {
                return v > new Date();
            },
            on_ok() {
                this.$refs["member-create"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post("member", this.form)
                            .then((response) => {
                                if (response.success) {
                                    this.on_cancel();

                                    if (this.callback) {
                                        this.callback(response.data);
                                    }
                                    this.$message.success(response.message);
                                } else {
                                    this.$error({
                                        title: "失败",
                                        centered: true,
                                        content: response.message,
                                    });
                                }
                            })
                            .catch(({ response }) => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_cancel() {
                this.$store.commit("change_member_create_visible", false);
            },
            after_close() {
                this.$refs["member-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));

                this.text_source = undefined;
            },
            on_mobile_change(e) {
                if (e.target.value.toString().length == 11) {
                    this.check_exists(e.target.value);
                }
            },
            check_exists(e) {
                this.phone_checking = true;
                this.$http
                    .get(`/member/check_exists?type=mobile&value=${e}`)
                    .then((response) => {
                        if (response.success) {
                            const data = response.data;
                            this.$warning({
                                title: `客户已经存在`,
                                centered: true,
                                content: `手机号码为【${e}】的客户，由【${data.user ? data.user.name : "已删除"}】录入于【${moment(
                                    data.created_at * 1000
                                ).format("YYYY-MM-DD HH:mm")}】`,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.phone_checking = false;
                    });
            },
            select_callback(source_info, promote_source_info) {
                this.$set(this.form, "source_id", source_info.id);
                // this.$set(this.form, "promote_source_id", promote_source_info.id);
                // this["text_source"] = source_info.title + "|" + promote_source_info.title;
                this["text_source"] = source_info.title ;
            },
            trademark_callback(e) {
                let ids = ''
                e.forEach((source) => {
                    ids += source.value + ','
                })
                ids = ids.substring(0,ids.length - 1)
                this.$set(this.form, "trademark_types", ids);
                this["text_trademark"] = ids;
            },
            on_area_select(value){
                this.form.member_area = value.join("/")
            },
            on_demand_select(value){
                this.form.demand_type = value.join(",")
            }
        },
    };
</script>

<style lang="less" scoped></style>
